import { render, staticRenderFns } from "./Lojaintegrada.vue?vue&type=template&id=60e95ea0&"
import script from "./Lojaintegrada.vue?vue&type=script&lang=js&"
export * from "./Lojaintegrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports